<img
    [src]="imageUrl()"
    [title]="imageTitle()"
    [style]="style()">
